import Vue from 'vue';

import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate);

import FormBlock from "@/Components/FormBlock";
import ContraIndicationTest from "@/Components/ContraIndicationTest";
import LocalizationStatusDot from "@/Components/LocalizationStatusDot";
import Actions from "@/Components/Actions";

new Vue({
    el: '#app',
    components: {
        ContraIndicationTest,
        FormBlock,
        LocalizationStatusDot,
        Actions,
    }
});
